import React from 'react';
import {
  People,
  Security,
  History,
  MonitorHeart,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

interface ManagementTab {
  label: string;
  path: string;
  icon: React.ReactElement;
  requiresGlobalAdmin?: boolean;
}

// Roles, Audit Log, and System Status are platform-level today (Roles
// exposes the Global Admin role definition, Audit Log isn't org-scoped
// yet, System Status is system-wide health). They're hidden from org
// admins until proper org-scoped variants exist. Mirrors the same
// gating in components/Layout/Sidebar.tsx so the in-page tab bar stays
// in sync with the sidebar.
const ALL_MANAGEMENT_TABS: ManagementTab[] = [
  { label: 'Users', path: '/management/users', icon: <People /> },
  { label: 'Roles', path: '/management/roles', icon: <Security />, requiresGlobalAdmin: true },
  { label: 'Audit Log', path: '/management/audit', icon: <History />, requiresGlobalAdmin: true },
  { label: 'System Status', path: '/system/status', icon: <MonitorHeart />, requiresGlobalAdmin: true },
];

export function useManagementTabs(): ManagementTab[] {
  const { user } = useAuth();
  const isGlobalAdmin = user?.global_role === 'global_admin';
  return ALL_MANAGEMENT_TABS.filter((t) => !t.requiresGlobalAdmin || isGlobalAdmin);
}

// Kept as a re-export for any code that needs the full list (e.g. tests).
// Production UI should always use useManagementTabs() so visibility tracks
// the current user.
export const MANAGEMENT_TABS = ALL_MANAGEMENT_TABS;

export const MANAGEMENT_ACCENT_COLOR = '#10b981';
